import { registerFeature } from "lib/features"

export const FEATURE_FLAG_REFRESH_ALL_MAPPINGS = registerFeature({
    numericalId: 2.4,
    description: "Enable the 'Refresh All Mappings' button in the asset mapping toolbar.",
    name: "Asset Mapping > Refresh All Mappings Button",
    id: "asset-mapping-refresh-all-mappings",
    internalUseOnly: true,
    readyForBeta: true,
})
